import { groupBy } from 'lodash-es';
import { useCommonImports } from '~/common/composables/common-imports.composable';

export function getFieldType(field) {
  return (typeof field?.config?.type === 'string' ? field.config.type : null) || field.properties.type || field.type;
}

export function handleFormDeleteErrorMessages(delete_response, forms_to_delete_count) {
  const { $toast, $t } = useCommonImports();

  const removed_forms = delete_response?.forms?.removed || [];
  const forms_with_error = delete_response?.forms?.errors || [];
  const group_by_error = groupBy(forms_with_error, error => error.code || 'UNKNOWN');
  const removed_form_text = removed_forms.length > 1 ? $t('forms') : $t('form');
  const bad_request_form_text = group_by_error?.BAD_REQUEST?.length > 1 ? $t('forms are integrated') : $t('form is integrated');

  // Success message If all forms are deleted
  if (removed_forms.length === forms_to_delete_count) {
    $toast({ text: `${$t('Successfully deleted')} ${removed_forms.length} ${removed_form_text}`, type: 'success' });
  }

  // Error message if some forms have error code BAD_REQUEST and some are deleted
  if (group_by_error?.BAD_REQUEST?.length) {
    if (removed_forms.length > 0) {
      const error_message = `${$t('Successfully deleted')} ${removed_forms.length}/${forms_to_delete_count} ${removed_form_text}. ${group_by_error?.BAD_REQUEST?.length} ${bad_request_form_text}. ${$t('Please remove the integration to delete them.')}`;
      $toast({ text: error_message, type: 'warning' });
    }
    else {
      $toast({ text: $t('Integrated forms cannot be deleted. Please remove the integration to delete them.'), type: 'error' });
    }
  }

  // Unauthorized errors
  if (group_by_error?.UNAUTHORIZED?.length) {
    const error_message = group_by_error?.UNAUTHORIZED?.[0]?.message;
    $toast({ text: error_message, type: 'error' });
  }
}
